import * as React from 'react';
import * as mui from '@mui/material';

import useStickyState from 'hooks/useStickyState';

import { useInventory } from 'models/CartItem';

import CharacterDialogButton from 'components/General/CharacterDialogButton';
import TextField from 'components/General/TextField';

const NotebookPage = () => {
	const [inventoryItems, isInventoryLoaded] = useInventory();

	const inventoryItem = inventoryItems.find(item => item.name === 'notebook1_gift') ?? inventoryItems.find(item => item.name === 'notebook1');

	const [name1, setName1] = useStickyState('', 'name1'); // Nome personaggio maglia rossa
	const [character1, setCharacter1] = useStickyState('', 'character1'); // Primo protagonista

	const [errorSnackbarOpen, setErrorSnackbarOpen] = React.useState(false);
	const [waiting, setWaiting] = React.useState(false);

	const wordpressData = window['wordpressData' as any] as any;

	const handleFinish = async () => {
		if (!inventoryItem) {
			return;
		}

		if (!name1 || !character1) {
			setErrorSnackbarOpen(true);
			return;
		}

		setWaiting(true);

		const body = {
			is_user_logged_in: wordpressData.is_user_logged_in,
			is_single: wordpressData.is_single,
			postid: wordpressData.postid,
		};

		const requestOptions: RequestInit = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			credentials: 'same-origin',
			body: JSON.stringify(body),
		};

		await fetch(
			`?add-to-cart=${inventoryItem.id}&name1=${name1}&name2=${name1}&name3=${name1}&character1=${character1}&character2=${character1}&character3=${character1}`,
			requestOptions,
		).then(() => {
			setWaiting(false);

			fetch('?wc-ajax=get_refreshed_fragments', requestOptions)
				.then(res => res.json())
				.then(res => {
					const newCount = res['fragments']['.nm-menu-cart-count'];

					Array.from(document.getElementsByClassName('nm-menu-cart-count')).forEach(item => {
						item.outerHTML = newCount;
					});

					window.location.href = '/carrello';
				});
		});
	};

	return (
		<>
			<mui.Backdrop style={{ zIndex: 10000 }} open={waiting}>
				<mui.CircularProgress color='inherit' />
			</mui.Backdrop>

			<mui.Typography variant='h5' align='center'>
				Personalizza il tuo quaderno Faboola!
			</mui.Typography>

			<mui.Typography variant='body1' align='center'>
				Scegli di seguito il nome e l'aspetto fisico per il personaggio in copertina.
			</mui.Typography>

			<mui.Box mt={2} width='100%' textAlign='center'>
				<img
					alt='notebook'
					src='https://faboo.la/wp-content/uploads/2021/04/Quaderno_placeholder.jpg'
					style={{ width: '100%', maxWidth: '600px' }}
				/>
			</mui.Box>

			<mui.Box width='100%' sx={{ bgcolor: 'primary.main', mt: 5, pb: 2 }}>
				<mui.Container maxWidth='lg'>
					<mui.Grid container spacing={5} direction='row' wrap='wrap'>
						<mui.Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
							<mui.Box
								sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', height: '100%' }}
							>
								<mui.Typography variant='h6'>
									{name1.length > 0
										? inventoryItem?.titles[0].replace(new RegExp('@UNIQUE_NAME', 'g'), name1)
										: inventoryItem?.titles[3]}
								</mui.Typography>
								<mui.Typography variant='body2'>
									<span
										dangerouslySetInnerHTML={{
											__html:
												(name1.length > 0
													? inventoryItem?.titles[1].replace(new RegExp('@UNIQUE_NAME', 'g'), name1)
													: inventoryItem?.titles[4]) ?? '',
										}}
									></span>
								</mui.Typography>
							</mui.Box>
						</mui.Grid>

						<mui.Grid item xs={12} sm={6} md={6} lg={7} xl={7}>
							<mui.Typography variant='body1' sx={{ mb: 1, fontWeight: 'bold' }}>
								1. Scrivi il nome del protagonista
							</mui.Typography>

							<TextField
								value={name1}
								setValue={setName1}
								placeholder='Nome primo protagonista'
								startIcon={
									character1 !== '' && (
										<img
											src={`https://storage.googleapis.com/faboola_wordpress_static/img/characters/${character1.toUpperCase()}.png`}
											loading='lazy'
											alt='first protagonist'
											width='35px'
											height='35px'
										/>
									)
								}
								errorMessage={"Inserisci un nome con meno di 20 caratteri e scegli l'aspetto"}
								StackProps={{ sx: { mb: 3 } }}
							/>

							<mui.Typography variant='body1' sx={{ mb: 1, fontWeight: 'bold' }}>
								2. {character1 === '' ? 'Scegli il suo aspetto' : 'Cambia il suo aspetto'}
							</mui.Typography>

							<mui.Box
								sx={{
									display: 'block',
									mb: 3,
									'& > *': {
										display: 'inline-block',
										mr: 2,
									},
								}}
							>
								<CharacterDialogButton index={1} isMale={false} selectedCharacter={character1} setSelectedCharacter={setCharacter1} />

								<CharacterDialogButton index={1} isMale={true} selectedCharacter={character1} setSelectedCharacter={setCharacter1} />
							</mui.Box>

							<mui.Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
								<mui.Button variant='contained' onClick={handleFinish} sx={{ mx: 1, my: 0 }}>
									Continua
								</mui.Button>
							</mui.Box>
						</mui.Grid>
					</mui.Grid>
				</mui.Container>
			</mui.Box>

			<mui.Snackbar
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				open={errorSnackbarOpen}
				onClose={() => setErrorSnackbarOpen(false)}
				autoHideDuration={3000}
			>
				<mui.Alert severity='error' variant='filled'>
					Attenzione! Hai dimenticato qualcosa. Verifica di aver inserito tutti i dati richiesti per accedere al prossimo passaggio 😉
				</mui.Alert>
			</mui.Snackbar>
		</>
	);
};

export default NotebookPage;
